import { render } from "./TmpPatientStatusCard.vue?vue&type=template&id=d9038b8e&scoped=true"
import script from "./TmpPatientStatusCard.vue?vue&type=script&lang=js"
export * from "./TmpPatientStatusCard.vue?vue&type=script&lang=js"

import "./TmpPatientStatusCard.vue?vue&type=style&index=0&id=d9038b8e&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9038b8e"]])

export default __exports__